import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import * as _ from 'underscore';
import { SiteWidget } from '../widget.interface';
import { CommonService } from 'src/app/shared/services/common.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-site-performance-widget',
	templateUrl: './site-performance-widget.component.html',
})
export class SitePerformanceWidgetComponent {
	@Input() widgetConfig: SiteWidget;
	@Input() devices: any;
	@Input() customerId: number;
	@Input() siteId: number;
	@Input() tableItems: any[] = [];
	@Input() chartTableConfig: any = {data: [], column: []};
	@Input() tableColumns: any[] = [];
	@Input() exportFileName: string = "";
	@Input() sizeColumnsToFit: boolean = true;
	@Input() tags: any[] = [];
	@Input() noDataForCurrentFilters: boolean = false;
	@Output() select = new EventEmitter<any>();
	@Output() filter = new EventEmitter<any>();

	@ViewChild('printFiltersRef') printFiltersRef: ElementRef;

	// date_range groups carry no label (see the widget configs) - everything else already sets a
	// real (if hardcoded English) label, which app-print-filters passes through translate untouched.
	private readonly filterGroupLabelKeys: { [name: string]: string } = {
		date_range: 'g.durations',
	};

	isCollapsed: boolean = false;
	itemsPerPage: number = 2;
	selectedDropDown: any;
	selectedTags: any[] = [];

	constructor(
		private commonService: CommonService,
		private translateService: TranslateService,
	) { }

	ngOnInit() {
		this.selectedDropDown = this.widgetConfig.selectedDropDown;
	}

	onSelect(event: string) {
		this.select.emit(event);
	}

	onFilter(event: any) {
		this.filter.emit(event);
	}

	// Feeds the shared <app-print-filters> table - printed via printFiltersRef.nativeElement.innerHTML in print() below.
	get printFilters(): { label: string, value: string }[] {
		const filters: { label: string, value: string }[] = [];

		for (const dropDownGroup of this.widgetConfig?.dropDownGroupList || []) {
			if (!dropDownGroup.options)
				continue;
			const value = this.selectedDropDown?.[dropDownGroup.name];
			const option = dropDownGroup.options.find(o => o.value == value);
			if (option)
				filters.push({ label: dropDownGroup.label || this.filterGroupLabelKeys[dropDownGroup.name] || dropDownGroup.name, value: option.label });
		}

		if (this.tags?.length && this.selectedTags?.length) {
			const tagNames = this.tags.filter(tag => this.selectedTags.includes(tag.id)).map(tag => tag.tag_name);
			if (tagNames.length)
				filters.push({ label: 'tags.tags', value: tagNames.join(', ') });
		}

		return filters;
	}

	onPrint() {
		let appendPrintContent = this.getPrintItems();
		return this.print({
			selectedDropDown: this.selectedDropDown,
			selectedTags: this.selectedTags,
			widgetId: this.widgetConfig.widgetId,
			appendPrintContent: appendPrintContent
		});
	}

	private print(options) {
		let addPrintHeaderFn		= options.addPrintHeaderFn,
			customerName			= options.customerName,
			siteName				= options.siteName,
			addPrintContentFn		= options.addPrintContentFn,
			widgetId				= options.widgetId,
			appendPrintContent		= options.appendPrintContent;

		let htmlContent = '';
		if (addPrintHeaderFn) {
			htmlContent+= addPrintHeaderFn();
		} else {
			htmlContent += '<div id="dvCompanyFullName"><h3>';
			if (customerName) {
				htmlContent += customerName;
				if (siteName) {
					htmlContent += ' / '+ siteName;
				}
			}
			htmlContent += '</h3></div>';
			// Dropdowns and tags render as a bordered filter table via the shared app-print-filters
			// component (ST-2101) - see the printFilters getter above.
			if (this.printFiltersRef?.nativeElement)
				htmlContent += this.printFiltersRef.nativeElement.innerHTML;
		}

		// additional content
		if (addPrintContentFn) {
			htmlContent+= addPrintContentFn();
		} else {
			if(widgetId) {
				const printId = widgetId.replace( /(:|\.|\[|\])/g, "\\$1" );
				const item = document.getElementById(printId);
				htmlContent+=  item.innerHTML;
			}
		}

		if(appendPrintContent) {
			htmlContent+= appendPrintContent;
		}

		this.commonService.printContent(htmlContent);
	}

	private getPrintItems() {
		let groups;
		groups = this.widgetConfig.groups;

		let html = '<div class="showOnPrint">';

		html += '<div class="page-break-inside">';
		html += '<span style="font-weight:bold;">'+this.widgetConfig.title+'</span>';
		html += '<table class="table table-striped table-condensed table-bordered"><thead>';
		let columns = this.tableColumns

		for (let columnIndex in columns) {
			html += '<th>'+columns[columnIndex].headerName+'</th>';
		}
		html += '</thead><tbody>';

		for (let itemIndex in this.tableItems) {
			let printItem = this.tableItems[itemIndex];
			html += '<tr>';
			for (let itemIndex in printItem) {
				html += '<td>';
				html += '<span>'+printItem[itemIndex]+'</span>';
				html += '</td>';
			}
			html += '</tr>';
		}
		html += '</tbody></table></div>';

		html += '</div>';
		return html;
	}
}
